// extracted by mini-css-extract-plugin
export default {"container":"header_container__UKnIj","breadcrumb":"header_breadcrumb__EvRG1"};